import { useEffect, useState } from 'react';
import jwt_decode from 'jwt-decode';
import { InventoryOrdersForTechnicalStaff } from './InventoryOrdersForTechnicalStaff';
import { InventoryOrdersForRMVendors } from './InventoryOrdersForRMVendors';

const InventoryOrderManagement = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      try {
        const decoded = jwt_decode(token);
        setUser(decoded);
      } catch (error) {
        console.error('Token decode failed:', error);
        setUser(null);
      }
    }
  }, []);

  if (!user) return null;

  switch (user.role) {
    case 'technical staff':
      return <InventoryOrdersForTechnicalStaff user={user} />;
    case 'rm vendor':
      return <InventoryOrdersForRMVendors user={user} />;
    default:
      return <div>Unauthorized or unknown role</div>;
  }
};

export { InventoryOrderManagement };
